<template>
    <div :class="timelineclass">
        <div v-if="reservations.total">
            <div
                v-for="reservation in reservations.page"
                :key="reservation.id"
                class="timeline__item"
                :class="{ 'timeline__item--in-past': isReservationInPast(reservation) }"
            >
                <div class="timeline__item--content" @click="goToReservation(reservation.id)">
                    <div class="timeline__item--content__status">
                        <reservation-status :status="reservation.status"></reservation-status>
                    </div>
                    <div class="timeline__item--content__div">
                        <div>
                            <p class="timeline__item--content__user">
                                <common-user-avatar
                                    v-if="reservation?.initiator"
                                    :user="reservation?.initiator"
                                    :shouldLeadToProfile="false"
                                    size="small"
                                ></common-user-avatar>
                                <span class="timeline__item--content__user--name">
                                    {{ getDisplayName(reservation) }}
                                </span>
                            </p>
                            <div>
                                <p
                                    v-if="!reservation.showPhone"
                                    class="contact__info--company--phone--link"
                                    @click="showPhone(reservation, $event)"
                                >
                                    {{ $t('components.user.user_card.click_phone') }}
                                </p>
                                <p
                                    v-if="reservation.showPhone && reservation?.initiator?.mobile"
                                    class="timeline__item--content__div--phone"
                                    @click.stop
                                >
                                    <a :href="`tel:${reservation.initiator.mobile}`">{{ reservation.initiator.mobile }}</a>
                                </p>
                            </div>
                        </div>

                        <div>
                            <p class="timeline__item--content__offer">
                                <b>{{ reservation?.availabilityOffer?.linkedOffer?.titleTextContent.originalText }}</b>
                                ({{ reservationPrice(reservation) }} {{ reservation.currency }})
                            </p>
                            <p
                                v-for="(item, index) in reservation?.calendarEventItems"
                                :key="index"
                                class="timeline__item--content__categories"
                            >
                                - {{ item?.offerCategory?.titleTextContent?.originalText }}
                            </p>
                        </div>
                    </div>

                    <div class="timeline__item--content__address">
                        <div>
                            {{ reservation?.availabilityOffer?.linkedOffer?.location?.address }}
                            ,
                            {{ reservation?.availabilityOffer?.linkedOffer?.location?.city?.name }}
                        </div>
                        <div class="timeline__item--content__address--time">
                            <p v-if="reservation.allowOverlapAfterMinutes" class="timeline__item--content__address--time">
                                {{
                                    getTime(
                                        reservation.startTime,
                                        reservation.date,
                                        reservation.availabilityOffer.linkedOffer.location.timeZone,
                                    )
                                }}
                                -
                                {{
                                    getOverlapTime(
                                        reservation.startTime + reservation.allowOverlapAfterMinutes,
                                        reservation.date,
                                        reservation.availabilityOffer.linkedOffer.location.timeZone,
                                    )
                                }}
                            </p>
                            <p v-else>
                                {{
                                    getTime(
                                        reservation.startTime,
                                        reservation.date,
                                        reservation.availabilityOffer.linkedOffer.location.timeZone,
                                    )
                                }}
                                -
                                {{
                                    getTime(
                                        reservation.endTime,
                                        reservation.date,
                                        reservation.availabilityOffer.linkedOffer.location.timeZone,
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="timeline__item--content__description">
                        <p>{{ reservation.description }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="timeline--empty">{{ $t('pages.reservations.reservation.no_timeline_reservation_message') }}</div>
    </div>
</template>

<script>
    import ReservationStatus from 'components/page-elements/reservations/ReservationStatus'
    import availabilityTransformer from 'transformers/availabilityTransformer'
    import dayjs from 'dayjs'
    import dayjsPluginUTC from 'dayjs/plugin/utc'
    import RoutesEnum from 'enums/routes.enum'
    import PriceMixin from 'mixins/PriceMixin'

    dayjs.extend(dayjsPluginUTC)

    export default {
        mixins: [PriceMixin],
        components: { ReservationStatus },

        props: {
            reservations: { type: Object, required: true },
        },

        computed: {
            timelineclass() {
                return {
                    timeline: true,
                    timeline__line: this.reservations.total,
                }
            },
        },

        methods: {
            isReservationInPast(reservation) {
                const startDate = dayjs.utc(reservation?.date).startOf('day').add(reservation?.startTime, 'm')
                return dayjs().utc().isAfter(startDate)
            },
            reservationPrice(reservation) {
                return this.setPrice(reservation[`paidPrice${reservation.currency}`])
            },
            getDate(date) {
                return dayjs.utc(date).format('DD.MM.YYYY')
            },
            getTime(time, date, timeZone) {
                return availabilityTransformer.minutesDateToLocalTZTime(time, date, timeZone)
            },

            getOverlapTime(time, date, timeZone) {
                return availabilityTransformer.minutesDateToLocalTZTime(time, date, timeZone)
            },

            getDateTime(date) {
                return dayjs(date).add(dayjs().utcOffset()).format('DD.MM.YYYY HH:mm')
            },

            goToReservation(id) {
                this.$router.push({ name: RoutesEnum.RESERVATIONS.SINGLE, params: { id } })
            },

            getDisplayName(reservation) {
                if (reservation?.initiator) {
                    return `${reservation?.initiator?.firstName} ${reservation?.initiator?.lastName}`
                }

                return
            },

            showPhone(reservation, event) {
                event.stopPropagation()
                reservation.showPhone = true
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/reservations/_timeline.scss';
</style>
